import React, { FormEvent } from 'react';
import { useForm } from 'react-hook-form/dist/index.ie11';
import {
  Button,
  Flex,
  Square,
  Squish,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import { GroupFields } from 'src/components/People/Groups/types';
import {
  addGroupEmptyFormValues,
  DESCRIPTION_MAX_LENGTH,
} from 'src/components/People/Groups/constants';
import { Input } from 'src/components/Input/Input';
import { IGroup } from 'src/utilities/useSearchHooks';
import { CookbookTextareaWrapper } from 'src/components/CookbookTextareaWrapper/CookbookTextareaWrapper';

interface IEditGroupFormProps {
  groupDataToEdit?: IGroup;
  onSubmit: (groupInfo: GroupFields) => void;
  onCancel: () => void;
}

export const ManageGroupForm: React.FC<IEditGroupFormProps> = ({
  groupDataToEdit,
  onSubmit,
  onCancel,
}) => {
  const { control, handleSubmit, register, errors, formState } =
    useForm<GroupFields>({
      mode: 'onChange',
      defaultValues: groupDataToEdit || addGroupEmptyFormValues,
    });

  const { isSubmitting, isValid } = formState;
  const isEditing = !!groupDataToEdit;
  const submitButtonName = isEditing ? 'Edit' : 'Add';

  return (
    <>
      <Stack y="x-sm">
        <Square inset="md">
          <form
            onSubmit={handleSubmit(
              (data: GroupFields, event: FormEvent<HTMLFormElement>) => {
                event.preventDefault();
                onSubmit(data);
              }
            )}
          >
            <Stack y="sm">
              <Input
                label="Group name"
                name="name"
                id="name"
                ref={register({
                  required: 'Group name is required',
                })}
                error={errors.name}
              />
            </Stack>

            <CookbookTextareaWrapper
              control={control}
              error={errors.description}
              id="description"
              name="description"
              label="Group description"
              placeholder="Eg. Design group in chicago location"
              rules={{
                maxLength: DESCRIPTION_MAX_LENGTH,
              }}
              maxLength={DESCRIPTION_MAX_LENGTH}
              minHeight={65}
              blockWidth
            />
          </form>
        </Square>
      </Stack>

      <Squish inset="md">
        <Flex flexDirection="row">
          <Stack width="50%" x="x-sm">
            <Button
              block
              variant="primary"
              buttonSize="medium"
              disabled={!isValid || isSubmitting}
              isLoading={isSubmitting}
              onClick={handleSubmit((data) => onSubmit(data))}
              name={submitButtonName}
            >
              {submitButtonName}
            </Button>
          </Stack>

          <Stack width="50%">
            <Button
              block
              variant="secondary"
              buttonSize="medium"
              disabled={isSubmitting}
              onClick={onCancel}
            >
              Cancel
            </Button>
          </Stack>
        </Flex>
      </Squish>
    </>
  );
};
